<template>
<div class="chapter">
<div class="inner_page">
<p class="fm-head">CONTENTS</p>
<p class="TOC"><a href="#/Acknowledgment">Acknowledgements</a></p>
<p class="TOC"><a href="#/Inmemory">“In Memory”</a></p>
<p class="TOC"><a href="#/Preface">Preface</a></p>
<p class="TOC1"><a href="#/Chapter1">A Startling Discovery</a></p>
<p class="TOC"><span href="#/Chapter2" title="Link target outside of Sample">Coming of Age in the Palm Beaches</span></p>
<p class="TOC"><span href="#/Chapter3" title="Link target outside of Sample">These Things Happen</span></p>
<p class="TOC"><span href="#/Chapter4" title="Link target outside of Sample">Investigation to Nowhere</span></p>
<p class="TOC"><span href="#/Chapter5" title="Link target outside of Sample">He Strangled Donald Trump’s Butler</span></p>
<p class="TOC"><span href="#/Chapter6" title="Link target outside of Sample">The Letter from Inside the Jail</span></p>
<p class="TOC"><span href="#/Chapter7" title="Link target outside of Sample">Guilty in Hindsight</span></p>
<p class="TOC1"><span href="#/Afterword" title="Link target outside of Sample">Afterword</span></p>
<p class="TOC"><span href="#/Afterglow" title="Link target outside of Sample">“After Glow”</span></p>
<p class="TOC"><span href="#/Bibliography" title="Link target outside of Sample">Bibliography</span></p>
<p class="TOC"><span href="#/Author" title="Link target outside of Sample">About the Author</span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Contents.vue?37c2848e